/** Build-time-safe (no Nuxt runtime dependency) so nuxt.config.ts can reuse it for the favicon href. */
export const resolveStaticAssetUrl = (origin: string | undefined, path: string): string => {
  if (origin === undefined || origin === '') return path

  const normalizedOrigin = origin.endsWith('/') ? origin.slice(0, -1) : origin
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${normalizedOrigin}${normalizedPath}`
}
